import "Styles/Pages/XPP/wlp.scss";
import { initLegacy } from "./initLegacy";
import { initBanner } from "./Banner/initBanner";
import { initSocialBanner } from "Pages/Components/SocialBanner/initSocialBanner";

declare global {
   interface Window {
      wlpModel?: Readonly<LSCommon.Service.LSWebUI.Models.XPP.WorkspaceLandingPageJsViewModel>;
   }
}

const model = window.wlpModel;

if (!model) {
   throw new Error("WLP model not found");
}

const wlpViewModel = initLegacy(model);

initBanner(model, startDate => { wlpViewModel.bookThisSpace({ startDate }); });

if (model.ShareReservation) {
   LSStore.instance.dispatch(LSStore.signingModalSlice.actions.setDefaultRegisterProps({
      RegistrationType: LSCommon.Enums.RegistrationType.ShareURL,
      RegistrationData: model.ShareReservation.Id
   }));
}
else {   
   if(model.EnterpriseAccountId && model.EnterpriseSocialActivityEnabled)
      initSocialBanner(model.EnterpriseAccountId, model.VenueId, "wlp-top-social-banner")
}